import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { GetGroupPriceCategoriesListDto } from 'src/app/core/api/models';
import { GroupPriceCategoriesService } from '../../../core/api/services/group-price-categories.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'group-price-category-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class GroupPriceCategorySearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  //#region properties
  isExistsItem: boolean = false;
  @Output('isShowGroupPrice') output_isShowGroupPrice =
    new EventEmitter<boolean>();
  //#endregion

  constructor(protected currentService: GroupPriceCategoriesService) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'categoryName';
    if (!this.label) this.label = 'common.groupPriceCategory';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) this.emitIsShowGroupPrice(this.items);
    super.ngOnChanges(changes);
  }

  getItemsApi() {
    if (!this.id) {
      this.items = [];
      this.initLoading = false;
      this.isFetchData = true;
      return;
    }
    this.initLoading = true;
    this.currentService
      .groupPriceCategoriesGetGroupPriceCategoriesList({
        OrganizationId: this.id || 1,
      })
      .pipe(this.basePipeOperators())
      .subscribe({
        next: (items) => {
          if (items?.data) {
            this.emitIsShowGroupPrice(items.data);
            this.items = items?.data;
          } else this.items = items.data;
          this.setDefaultValue();
        },
        error: (error) => {
          this.emitError();
        },
        complete: () => {
          this.initLoading = false;
          this.isFetchData = true;
        },
      });
  }

  emitIsShowGroupPrice(items: GetGroupPriceCategoriesListDto[]) {
    this.isExistsItem = items?.some((item) => {
      return item.id == this.value;
    });
    this.output_isShowGroupPrice.emit(this.isExistsItem);
  }
}
